// extracted by mini-css-extract-plugin
export default {"wrapper":"NewWithDropdown__wrapper___z4SYU","dropdown":"NewWithDropdown__dropdown___HWKOC","new":"NewWithDropdown__new___bjnYd","active":"NewWithDropdown__active___pxlY7"};